import { Fragment, useEffect, useState } from "react";
import GetActiveUsersCount from "../../api-layer/active-users-api/GetActiveUsersCount";
import { persianLanguage } from "../../../constants/persianTerms";
import { persianDigitPrice } from "../../../shared/persian-number";

export default function ActiveUsersCount(){
    const [count, setCount] = useState(null);

    useEffect(() => {
        getActiveUsers();

        // Set up interval for subsequent fetches
        const intervalId = setInterval(getActiveUsers, 60000); // 60000ms = 1 minute

        // Cleanup on unmount
        return () => clearInterval(intervalId);
    },[

    ]);

    const getActiveUsers = () => {
        GetActiveUsersCount().then(
            response => {
                setCount(response.data);            
            }
        ).catch(
            error => {
                setCount(null);
            }
        );
    }

    if (count && Number.isInteger(count.active_count) && count.active_count >= 0){
        return (
            <Fragment>
                <div>
                    {persianLanguage.word.user.USERS} {persianLanguage.word.general.ACTIVE}: {persianDigitPrice(count?.active_count)}
                </div>
            </Fragment>
        );
    } else {
        return (
            <div></div>
        );
    }

}